module.exports = new __parcel__URL__("exercise6.4981aff6.png").toString();